import React from 'react';
import PropTypes from 'prop-types';

import { EntitiesAdapterForFulfillmentPlannerContext } from '../../../fulfillment-planner';
import { GridLayout } from './grid-layout';
import { Header } from './header';
import { ORDER_DETAILS_CANVAS } from '../../../constants/component-names';
import { useEntitiesFulfillmentPlan } from '../../../hooks/entities/selectors/fulfillment-plans';

import style from './style.module.less';

export const Overview = ({ fulfillmentPlanId }) => {
  const isFulfillmentPlanLoaded = !!useEntitiesFulfillmentPlan(fulfillmentPlanId);

  return (
    isFulfillmentPlanLoaded && (
      <EntitiesAdapterForFulfillmentPlannerContext
        key={fulfillmentPlanId}
        fulfillmentPlanId={fulfillmentPlanId}
        parentComponentName={ORDER_DETAILS_CANVAS}
      >
        <div className={style['overview-background']}>
          <div className={style.overview}>
            <Header />
            <GridLayout />
          </div>
        </div>
      </EntitiesAdapterForFulfillmentPlannerContext>
    )
  );
};

Overview.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
